export default __webpack_public_path__ + "static/media/filter.440ce17b.svg";